import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronRight } from "../../../ui/icons";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getOrganisationalStructure } from "../../../store/organisationalSlice";
import {Link} from "react-router-dom";
import useWindowWidth from "../../../ui/hooks/useWindowWidth";

const Second = () => {
    const [activeTab, setActiveTab] = useState("info2");
    const [tab,setTab] = useState("PRESIDENT")
    const dispatch = useDispatch();
    const width = useWindowWidth();
    const {organisationalStructure} = useSelector((state) => state.organisationalStructure);
    const swiperRef = useRef(null);
    const arrTabs = [
        {
            id:1,
            category:"PRESIDENT",
        },
        {
            id:2,
            category:"VICE-PRESIDENT",
        },
        {
            id:3,
            category:"DIRECTOR",
        },
        {
            id:4,
            category:"ACADEMIC COUNCIL",
        },
        {
            id:5,
            category:"SELECTION COMMITTEE",
        },
    ]
    useEffect(() => {
        dispatch(getOrganisationalStructure())
    },[])
    const handleTabClick = (tab) => {
        setActiveTab(activeTab === tab ? "" : tab);
    };

    const Hidden = styled.div`
        @media (max-width: 1032px) {
            display: none !important;
        }
    `;

    const Img = styled.img`
        @media (max-width: 1032px) {
            width: 60% !important;
        }
    `;
    return (
        <section className="bg-[#0A1F44] min-h-screen flex flex-col md:flex-row pb-10">
            <div className={`w-full md:w-1/4 bg-[#0A1F44] flex md:flex-col ${width < 500 ? "overflow-x-scroll" : ""}`}>
                <button
                    className={`w-full font-[600] text flex justify-center sm:justify-between items-center p-4 transition-all duration-300 uppercase ${activeTab === "info1" ? "bg-white text-black" : "bg-[#8C1C1C] text-white"
                        }`}
                    onClick={() => handleTabClick("info1")}
                >
                    About OAA
                    {activeTab === "info1" ? <Hidden><ChevronRight className="w-5 h-5" /></Hidden> :
                        <Hidden><ChevronDown className="w-5 h-5" /></Hidden>}
                </button>

                <button
                    className={`w-full uppercase font-normal flex justify-between items-center p-4  transition-all duration-300 ${activeTab === "info2" ? "bg-white text-black" : "bg-[#8C1C1C] text-white"
                        }`}
                    onClick={() => handleTabClick("info2")}
                >
                    Organisational Structure
                    {activeTab === "info2" ? <Hidden><ChevronRight className="w-5 h-5" /></Hidden> :
                        <Hidden><ChevronDown className="w-5 h-5" /></Hidden>}
                </button>
                {activeTab === "info2" ?
                    arrTabs.map(item => (
                        <button
                            className={`w-full uppercase font-normal flex justify-between items-center p-4  transition-all duration-300 ${tab === item.category ? "bg-[#BA7373] text-white" : "bg-white text-black"
                            }`}
                            onClick={() => setTab(item.category)}
                        >
                            {item.category}
                            {tab === item.category ? <Hidden><ChevronRight className="w-5 h-5"/></Hidden> :
                                <Hidden><ChevronDown className="w-5 h-5"/></Hidden>}
                        </button>
                    ))
                    : ""
                }
            </div>

            <div className="w-full md:w-3/4 p-3 flex text-white text-lg font-semibold ">
                {activeTab === "info1" &&
                    <div className="w-full">
                        <h2 className="text-[24px] sm:text-[30px] font-normal pb-2 text-center">About OAA</h2>
                        <hr className="bg-white"/>
                        <div className="text-[25px] sm:text-[25px] font-[400] p-3 grid gap-6 ">
                            <p className='text-center'>
                                    Our instructors are well-known experts and industry professionals with a vast,
                                    first-hand experience in handling hundreds of complex multi-jurisdictional
                                    arbitrations.
                                </p>
                                <p className='text-center'>
                                    The OAA allows you to access the courses wherever in the world you are, making it
                                    convenient for you to learn at your own pace and schedule. The students will not
                                    only
                                    gain theoretical knowledge but will also receive practical insights and guidance
                                    from
                                    seasoned professionals, who have dealt with diverse legal and cultural environments.
                                </p>
                                <p className='text-center'>
                                    Join us at the OAA to embark on a journey towards becoming an arbitration
                                    specialist.
                                </p>
                            </div>
                            <div className='grid gap-6 w-full text-center'>
                                <div className='text-lg font-normal p-3 grid gap-4 text-[25px] items-center'>
                                    <h2 className='text-center bg-[#8C1C1C] w-full'>
                                        Recorded Lectures
                                    </h2>
                                    <div className='flex justify-center'>
                                        <p className='xl:w-[950px] text-[25px] text-center'>
                                            A series of in-depth and expertly crafted lectures delivered by globally
                                            renowned
                                            authorities in international arbitration, ensuring a rigorous and
                                            intellectually
                                            enriching experience.
                                        </p>
                                    </div>
                                </div>
                                <div className='text-lg font-normal p-3 grid gap-4 text-[25px]'>
                                    <h2 className='text-center bg-[#8C1C1C]'>
                                        Exclusive Seminars
                                    </h2>
                                    <div className='flex justify-center'>
                                        <p className='xl:w-[950px] text-[25px]'>
                                            High-impact, interactive seminars led by Norair, a preeminent thought leader
                                            whose
                                            expertise reshapes contemporary arbitration practices.
                                        </p>
                                    </div>
                                </div>
                                <div className='text-lg font-normal p-3 grid gap-4 text-[25px]'>
                                    <h2 className='text-center bg-[#8C1C1C]'>
                                        Private Discussion Groups
                                    </h2>
                                    <div className='flex justify-center'>
                                        <p className='xl:w-[950px] text-[25px]'>
                                            Membership in exclusive, closed discussion forums where participants can
                                            exchange
                                            ideas, seek insights, and establish meaningful professional relationships.
                                        </p>
                                    </div>
                                </div>
                                <div className='text-lg font-normal p-3 grid gap-4 text-[25px]'>
                                    <h2 className='text-center bg-[#8C1C1C]'>
                                        International Networking Opportunities
                                    </h2>
                                    <div className='flex justify-center'>
                                        <p className='xl:w-[950px] text-[25px]'>
                                            Direct access to an elite network of international arbitration experts and
                                            practitioners, opening doors to unparalleled career advancement
                                            opportunities.
                                        </p>
                                    </div>
                                </div>
                                <div className='text-lg font-normal p-3 grid gap-4 text-[25px]'>
                                    <h2 className='text-center bg-[#8C1C1C]'>
                                        Unique Learning Materials
                                    </h2>
                                    <div className='flex justify-center'>
                                        <p className='xl:w-[950px] text-[25px]'>
                                            Proprietary resources and case studies, crafted specifically for this course
                                            and
                                            unavailable in any public domain, fostering advanced strategic thinking.
                                        </p>
                                    </div>
                                </div>
                                <div className='text-lg font-normal p-3 grid gap-4 text-[25px]'>
                                    <h2 className='text-center bg-[#8C1C1C]'>
                                        Specialized Literature Access
                                    </h2>
                                    <div className='flex justify-center'>
                                        <p className='xl:w-[950px] text-[25px]'>
                                            Access to a curated library of essential arbitration texts and exclusive
                                            publications throughout the duration of the course.
                                        </p>
                                    </div>
                                </div>
                                <div className='text-lg font-normal p-3 grid gap-4 text-[25px]'>
                                    <h2 className='text-center bg-[#8C1C1C]'>
                                        Priceless Experience
                                    </h2>
                                    <div className='flex justify-center'>
                                        <p className='xl:w-[950px] text-[25px]'>
                                            First-hand knowledge and insights from real-world multi-jurisdictional
                                            arbitration
                                            cases, imparted by seasoned practitioners with decades of experience.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {activeTab === "info2" &&
                        <div className=''>
                            <h2 className="text-2xl font-normal mb-2 text-center sm:text-left">Organizational
                                Structure</h2>
                            <hr className="bg-white"/>
                            <p className="font-semibold text-[30px] sm:text-[25px] mb-[24px] mt-[30px]">{tab}</p>
                            <div className={`grid ${width < 500 ? "grid-cols-1" : "grid-cols-2"}`}>
                                {organisationalStructure?.filter(item => item.status === tab).map((item, index) => (
                                    <Link to={item.description} target="_blank" className="w-full"
                                          key={item.id}>
                                        <div className="w-full font-normal p-[24px]">
                                            <div className="grid gap-4 items-start text-center sm:text-left">
                                                <div className="w-full col-span-1 sm:block ">
                                                    <img
                                                        className="pt-[20px] sm:pt-0 !w-[350px] h-[350px] object-cover sm:w-full"
                                                        src={item.photo}
                                                        alt=""
                                                    />
                                                </div>
                                                <div className='grid gap-2 w-full'>
                                                    <p className="font-semibold text-[22px] sm:text-[25px">{item.full_name}</p>
                                                    <p className="text-[#EAEAEA] opacity-80 text-[16px] sm:text-[18px]">{item.location === "'" ? '' : item.location}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>

                        </div>
                    }
                {activeTab === "" && <p>Select an option</p>}
            </div>
        </section>
                    );
                };

                export default Second;
